









































































































































































import { Vue, Component } from "vue-property-decorator";
import Customer from "@/components/Sidebar/Customer/Customer.vue";
import ModalCustomer from "@/components/Modal/ModalCustomer.vue";
import { StoreModule } from "@/store/types";
import { CustomerGetters } from "@/store/modules/customer/types";
import { UserGetters } from "@/store/modules/user/types";
import { namespace } from "vuex-class";
import { SalesRegions } from "@/models/map/region_type";
import { CustomerStatus, CustomerType } from "@/models/customer";
import { CustomerSchema } from "@/models/customer_schema";
import { EventBus } from "@/events/index";
import SalesRegionMap from "@/models/map/region";
import Search from "@/components/Sidebar/Search.vue";
import { Roles } from "@/models/roles";
import UIkit from "uikit";
import moment from "moment";
import simplebar from "simplebar-vue";
import { RepGetters, RepActions } from "@/store/modules/rep/types";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import { Layers } from "@/models/map/layers";
import { ExportActions } from "@/store/modules/export/types";

@Component({
  components: {
    Customer,
    ModalCustomer,
    Search,
    simplebar,
  },
})
export default class CustomerList extends Vue {
  protected region: SalesRegions["string"] | "" = "";
  protected CustomerStatus = CustomerStatus;
  protected CustomerType = CustomerType;
  protected SalesRegionMap = SalesRegionMap;
  protected filter: "" | CustomerStatus | "new" = CustomerStatus.Current;
  protected customer_type: "" | CustomerType = "";
  protected sort = "asc";
  protected searchTerm = "";
  protected Roles = Roles;
  protected Layers = Layers;
  @(namespace(StoreModule.Customer).Getter(CustomerGetters.GetAllCustomers))
  customers!: CustomerSchema[];
  @(namespace(StoreModule.User).Getter(UserGetters.GetRole)) role;
  @(namespace(StoreModule.Rep).Getter(RepGetters.GetSelected))
  selected!: CustomerSchema;
  @(namespace(StoreModule.Rep).Action(RepActions.SetSelectedRep))
  addActiveRep;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetActiveView))
  activeView;
  @(namespace(StoreModule.Export).Action(ExportActions.AddExportFilters))
  addExportFilters;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddLoading)) setLoading;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetLoading)) isLoading;

  created() {
    if (this.$route.query.region) {
      this.region = this.$route.query.region as SalesRegions["string"];
    }
    if (this.$route.query.status) {
      this.selectFilter(this.$route.query.status as CustomerStatus);
    } else {
      this.setLoading(true);
      EventBus.$emit("filterMarkers", this.filter); //default, current
      setTimeout(() => this.setLoading(false), 600);
    }
    EventBus.$on("getExportData", () => {
      this.addExportFilters({
        data: "customer",
        region: this.region,
        customer_type: this.customer_type,
        status: this.filter,
        layer: this.getActiveView(),
      });
    });
  }

  beforeDestroy() {
    EventBus.$off("getExportData");
  }

  public getActiveView(): object {
    let layer = {};
    if (this.activeView === Layers.Contract) {
      layer = { handle: Layers.Contract, displayName: "Contract Dealers" };
    } else if (this.activeView === Layers.Beach) {
      layer = { handle: Layers.Beach, displayName: "Beach Concessionaires" };
    } else {
      layer = { handle: Layers.Customers, displayName: "Retail & Design" };
    }
    return layer;
  }

  get customerTypeOptions(): CustomerType[] {
    return [this.CustomerType.Customer, this.CustomerType.Designer];
  }

  public makeTitleCase(option: string) {
    return option
      .toLowerCase()
      .split(" ")
      .map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  }

  public triggerSearch(searchTerm: string) {
    this.searchTerm = searchTerm;
  }

  protected activityUpdate(time: string | null): string | false {
    let update;
    if (!time) {
      update = false;
    } else {
      const now = moment();
      const then = moment(time);
      const difference = now.diff(then, "days");
      if (difference === 0) {
        update = "Less than a day ago";
      } else if (difference === 1) {
        update = "1 day ago";
      } else {
        update = difference + " days ago";
      }
    }
    return update;
  }

  public makeSentenceCase(option: string) {
    return option.charAt(0).toUpperCase() + option.slice(1);
  }

  get regionList(): string[] {
    const values: string[] = [];
    for (const [key, value] of this.SalesRegionMap.entries()) {
      values.push(value);
    }
    return values;
  }

  get filteredCustomers(): CustomerSchema[] {
    let regionArray = this.customers;
    if (this.activeView === Layers.Contract) {
      regionArray = regionArray.filter((customer) => {
        return customer.customer_type === CustomerType.Contract;
      });
    } else if (this.activeView === Layers.Beach) {
      regionArray = regionArray.filter((customer) => {
        return customer.customer_type === CustomerType.BeachConcession;
      });
    } else {
      regionArray = regionArray.filter((customer) => {
        return (
          customer.customer_type === CustomerType.Customer ||
          customer.customer_type === CustomerType.Designer
        );
      });
    }
    if (this.region && this.activeView === Layers.Customers) {
      regionArray = this.customers.filter((customer) => {
        return (
          customer.sales_region === this.region &&
          (customer.customer_type === CustomerType.Customer ||
            customer.customer_type === CustomerType.Designer)
        );
      });
    }
    if (this.searchTerm) {
      regionArray = regionArray.filter((customer) => {
        return customer.customer_name
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase());
      });
    }
    if (this.customer_type) {
      regionArray = regionArray.filter((customer) => {
        return customer.customer_type === this.customer_type;
      });
    }
    EventBus.$emit("sendFooterData", regionArray);
    if (this.filter) {
      if (this.filter === "new") {
        // a customer is "new"  if it is marked current & was customer since at less than or equal to a year from this date
        regionArray = regionArray.filter((customer) => {
          return (
            customer.customer_since &&
            customer.status === CustomerStatus.Current &&
            moment().diff(moment(customer.customer_since), "years", true) <= 1
          );
        });
      } else {
        regionArray = regionArray.filter((customer) => {
          return customer.status === this.filter;
        });
      }
    }
    if (this.sort === "asc") {
      regionArray.sort((first, second): any => {
        if (first.customer_name < second.customer_name) return -1;
        if (first.customer_name > second.customer_name) return 1;
      });
    }
    if (this.sort === "desc") {
      regionArray.sort((first, second): any => {
        if (first.customer_name < second.customer_name) return 1;
        if (first.customer_name > second.customer_name) return -1;
      });
    }
    return regionArray;
  }

  public selectRegion(region: SalesRegions["string"] | "") {
    if (this.selected._id && region !== this.selected.sales_region) {
      this.addActiveRep({});
    }
    this.region = region;
    if (!region) {
      this.flyToFull();
    } else {
      this.flyToRegion();
    }
  }

  public selectFilter(filter: CustomerStatus | "" | "all") {
    this.setLoading(true);
    UIkit.dropdown(this.$refs.filter).hide(false);
    if (filter === "all") {
      this.filter = "";
    } else {
      this.filter = filter;
    }
    if (this.filter !== CustomerStatus.Current) {
      const status = this.filter ? this.filter : "all";
      const filterQ = "status=" + status;
      history.replaceState(
        {},
        "",
        this.$route.path +
          (this.$route.query.region
            ? "?region=" + this.$route.query.region + "&" + filterQ
            : "?" + filterQ)
      );
    } else {
      if (this.$route.query.status) {
        history.replaceState(
          {},
          "",
          this.$route.path +
            (this.$route.query.region
              ? "?region=" + this.$route.query.region
              : "")
        );
      }
    }
    EventBus.$emit("filterMarkers", this.filter);
    setTimeout(() => this.setLoading(false), 600);
  }

  public selectType(type: CustomerType | "") {
    UIkit.dropdown(this.$refs.type).hide(false);
    this.customer_type = type;
  }

  public selectSort(sort: "asc" | "desc") {
    UIkit.dropdown(this.$refs.sort).hide(false);
    this.sort = sort;
  }

  public flyToRegion(): void {
    if (this.region != this.$route.query.region)
      this.$router.push({
        path: "/customers",
        query: { region: this.region, status: this.filter },
      });
  }

  public flyToFull(): void {
    if (this.$route.query.region) {
      this.region = "";
      this.$router.push({
        path: "/customers",
        query: { status: this.filter },
      });
    }
  }

  protected triggerAddCustomer() {
    this.$modal.show(
      ModalCustomer,
      {},
      { adaptive: true, width: 860, height: "auto", scrollable: true }
    );
  }
}
